<template>
    <preview-carousel v-bind:isMine="true" v-bind:idTemplate="templateId"/>
</template>

<script>
import PreviewCarousel from "./PreviewCarousel";

export default {
  name: "PreviewCarouselMine",
    data: function() {
    return { templateId: "" };
  },
  created: function() {
    this.templateId = this.$route.params.id;
  },
  components: { PreviewCarousel }
};
</script>